import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './index.css';
import Conviction from './Conviction';
import Fundamental from './Fundamental';
import Weighted from './Weighted';
import Dynamic from './Dynamic';

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/portefeuilleweging" element={<Weighted />} />
        <Route path="/conviction" element={<Conviction />} />
        <Route path="/privatebanking" element={<Dynamic includeComparison />} />
        <Route path="/dynamic" element={<Dynamic />} />
        <Route path="/veiligheid" element={<Fundamental includeComparison />} />
        <Route path="/fundamental" element={<Fundamental />} />
      </Routes>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);
